import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2507380620/src/Land-Based-CasinoStars-Admin/src/components/common/page-loader/page.jsx");
